import * as _uicomponents from './uicomponents'

export default _uicomponents